import { Box, Button, Center, Flex, Icon, Spinner, Text, useTheme } from '@chakra-ui/react';
import React, { useContext } from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import { BiExpand } from 'react-icons/bi';
import { FiMinimize } from 'react-icons/fi';
import { SizeContext } from '../../pages/Main/Operacoes';
import { BMF } from '../../types/OperaroesTypes';

type ListaBMFType = {
    visible: boolean
    load: boolean
    lista: BMF[]
}

const ListaBMF: React.FC<ListaBMFType> = (prop) => {
    const { isSize, toggleSize } = useContext(SizeContext);
    const theme = useTheme();
    const column: TableColumn<BMF>[] = [
        {
            name: "Dia",
            selector: (e) => e.dia,
            sortable: true,
            width: "48px",
            compact: true
        },
        {
            name: "Qtd Contratos Dólar",
            selector: (e) => e.qtdContratosDolar,
            sortable: true,
            compact: true
        },

        {
            name: "Qtd Contratos Indice",
            selector: (e) => e.qtdContratosIndice,
            sortable: true,
            compact: true
        },
        {
            name: "Qtd Total Contratos",
            selector: (e) => e.qtdTotalContratos,
            sortable: true,
            compact: true,
            style: {
                borderRight: `3px solid ${theme.colors.secondary["100"]}`
            }
        },
        {
            name: "Custo Dólar",
            selector: (e) => e.custoDolar,
            sortable: true,
            compact: true
        },
        {
            name: "Custo Indice",
            selector: (e) => e.custoIndice,
            sortable: true,
            compact: true,
            style: {
                borderRight: `3px solid ${theme.colors.secondary["100"]}`
            }
        },
        {
            name: "Bruto",
            selector: (e) => e.bruto,
            sortable: true,
            compact: true
        },
        {
            name: "Custo",
            selector: (e) => e.custo,
            sortable: true,
            compact: true
        },
        {
            name: "Fatura",
            selector: (e) => e.saldo,
            sortable: true,
            compact: true
        },
    ]

    return (
        <Box display={prop.visible ? "block" : "none"}>
            <Flex justifyContent="space-between" alignItems="center">
                <Text pb="4" pt="4" fontWeight="bold" fontSize="1.4rem">Movimentações BMF</Text>
                <Button
                    variant="primary-outline"
                    onClick={() => toggleSize()}
                >
                    <Icon as={isSize ? FiMinimize : BiExpand} />
                </Button>
            </Flex>
            <Box bg='white.100' p='8' borderRadius="16px" boxShadow="0px  8px 28px #00000006" >
                <DataTable
                    columns={column}
                    data={prop.lista}
                    progressPending={prop.load}
                    highlightOnHover
                    fixedHeader
                    fixedHeaderScrollHeight='50vh'
                    customStyles={{
                        cells: {
                            style: {
                                fontSize: "10px",
                                fontWeight: "bold"
                            }
                        }
                    }}
                    noDataComponent={
                        <Center p="8">
                            <Text>Nenhum BMF encontrado.</Text>
                        </Center>
                    }
                    progressComponent={
                        <Center p="20">
                            <Spinner
                                w="80px"
                                h="80px"
                                color="red.100"
                                thickness='8px'
                            />
                        </Center>
                    }
                />
            </Box>
        </Box>
    );
}

export default ListaBMF;